<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part">PART ONE </h2>
<h2 class="parta"><em class="italic">Common sense is instinct, and enough of it is genius.</em></h2>
<p class="rightt"><em class="italic">—</em>H. W. S<span class="small">HAW</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part1.vue?06627d5b